import { ShieldCheck } from "lucide-react";
import { PageShell } from "./page-shell";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { EmptyState, ErrorState } from "@/components/common/empty-state";
import { useAdmins } from "@/lib/queries";
import { formatDate } from "@/lib/utils";

export function AdminsPage() {
  const { data, isLoading, isError, refetch } = useAdmins();

  return (
    <PageShell
      title="Admins"
      description="Team members with access to this panel. Provisioning happens automatically on first SSO sign-in."
    >
      <div className="rounded-lg border border-line bg-surface">
        {isLoading ? (
          <div className="space-y-2 p-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-full" />
            ))}
          </div>
        ) : isError ? (
          <ErrorState title="Couldn't load admins" onRetry={() => void refetch()} />
        ) : !Array.isArray(data) || data.length === 0 ? (
          <EmptyState
            icon={ShieldCheck}
            title="No admins yet"
            description="The first SSO sign-in will provision the owner account."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Username</TableHead>
                <TableHead>Role</TableHead>
                <TableHead className="text-right">Joined</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((admin) => (
                <TableRow key={admin.id}>
                  <TableCell className="font-medium text-ink">{admin.full_name || "—"}</TableCell>
                  <TableCell className="text-ink-muted">{admin.username}</TableCell>
                  <TableCell>
                    <Badge tone={admin.role === "owner" ? "accent" : "outline"}>{admin.role}</Badge>
                  </TableCell>
                  <TableCell className="text-right text-sm text-ink-muted">{formatDate(admin.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </PageShell>
  );
}
